// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
})();

document.addEventListener('DOMContentLoaded', function () {
    const toggles = document.querySelectorAll('.menu-item.toggle'); // Selecciona todos los toggles del menú

    toggles.forEach(toggle => {
        toggle.addEventListener('click', function (e) {
            e.preventDefault();

            const accordionId = this.getAttribute('data-toggle-accordion'); // Obtén el ID del acordeón
            const accordion = document.getElementById(accordionId);

            // Cierra otros acordeones abiertos
            document.querySelectorAll('.accordion.show').forEach(openAccordion => {
                if (openAccordion !== accordion) {
                    openAccordion.classList.remove('show');
                }
            });

            // Alternar el acordeón actual
            if (accordion) {
                accordion.classList.toggle('show');
            }
        });
    });
});






